import { get, isNull } from 'lodash';

import { FETCH_PRODUCT_DATASHEET_SUCCESS } from '../actionTypes';
import { productDatasheetsActions } from '../reducer';

import showForm from './showForm';

export default (data) => (dispatch) => {
    dispatch(productDatasheetsActions[FETCH_PRODUCT_DATASHEET_SUCCESS](data));
    if (isNull(get(data, 'data_sheet', null))) dispatch(showForm(true));
};
